import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { apiFetch, ApiClientError } from "@/lib/api-client";
import { queryKeys } from "@/lib/query-keys";

export type DeleteRowInput = {
  programId: string;
  id: string;
};

// DELETE /api/admin/tiers/programs/:programId/rows/:id
//
// Pessimistic. Cells cascade via FK ON DELETE CASCADE so the server-side
// state collapses cleanly; the refetch reflects the result.
export function useDeleteTierRow() {
  const queryClient = useQueryClient();
  return useMutation<void, ApiClientError, DeleteRowInput>({
    mutationFn: ({ programId, id }) =>
      apiFetch<void>(`/admin/tiers/programs/${programId}/rows/${id}`, {
        method: "DELETE",
      }),
    onSuccess: (_data, { programId }) => {
      queryClient.invalidateQueries({ queryKey: queryKeys.tiers.program(programId) });
    },
    onError: (err) => {
      toast.error(err.message ?? "Failed to delete row");
    },
  });
}
